import { SET_COMPANY } from '../../actionTypes';
import { debugAction } from '../../utils';

export const company = {
  data: ''
};

export function companyReducer(state = company, action) {
  debugAction(action);
  switch (action.type) {
    case SET_COMPANY:
      return { data: action.payload };
    default:
      return { ...state };
  }
}